import { __read, __spreadArray } from "tslib";
export var BannerActionType;
(function (BannerActionType) {
    BannerActionType["addBanner"] = "addBanner";
    BannerActionType["removeBanner"] = "removeBanner";
})(BannerActionType || (BannerActionType = {}));
export var BannerReducer = function (state, action) {
    switch (action.type) {
        case BannerActionType.addBanner:
            if (state.banners.some(function (b) { return b.id === action.banner.id; })) {
                // Banner with id already exists. No-op.
                return state;
            }
            // Add banner
            return { banners: __spreadArray(__spreadArray([], __read(state.banners), false), [action.banner], false) };
        case BannerActionType.removeBanner:
            var banners = state.banners.filter(function (b) { return b.id !== action.id; });
            return { banners: banners };
    }
};
//# sourceMappingURL=reducer.js.map